/**
 * TanStack Query hooks for `report-api-custom-columns`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	reportApiCustomColumnsQueryKeys,
	type CreateReportApiCustomColumnsBody,
	type ListReportApiCustomColumnsResponse,
	type ReportApiCustomColumnsRow,
} from "./api";

export function useReportApiCustomColumnsList(): UseQueryResult<ListReportApiCustomColumnsResponse, Error> {
	return useQuery({
		queryKey: reportApiCustomColumnsQueryKeys.list(),
		queryFn: list,
	});
}

export function useReportApiCustomColumnsCreate(): UseMutationResult<ReportApiCustomColumnsRow, Error, CreateReportApiCustomColumnsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: reportApiCustomColumnsQueryKeys.all });
		},
	});
}

export function useReportApiCustomColumnsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: reportApiCustomColumnsQueryKeys.all });
		},
	});
}
